<template>
  <g
    class="segment"
    :class="classes"
    :aria-label="`Spine Segment ${segment.key}`"
    :data-testid="`spine-segment-${segment.key}`"
    @mouseover="segmentMouseOver"
    @mouseout="segmentMouseOut"    
    @click="segmentClick"
  >
    <path :d="segment.fillD" />
    <path class="outline" :d="segment.outlineD" />
  </g>
</template>

<script>
export default {
  name: 'spine-segment',
  props: {
    segment: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes()  {
      return `${this.segment.key} ${this.selected ? 'selected' : ''}`
    },
  },
  methods: {
    segmentMouseOver() {
      this.$emit('mouseover', this.segment.key);
    },
    segmentMouseOut() {
      this.$emit('mouseout')
    },
    segmentClick() {
      this.$emit('click', this.segment.key);
    },
  }
}
</script>

<style scoped>
.segment {
  cursor: pointer;
}

.C1, .C2, .C3, .C4, .C5, .C6, .C7 {
  fill:#93b6d9;
}

.C1:hover, .C2:hover, .C3:hover, .C4:hover, .C5:hover, .C6:hover, .C7:hover {
  fill: #286db3;
}

.C1.selected, .C2.selected, .C3.selected, .C4.selected, .C5.selected, .C6.selected, .C7.selected {
  fill: #286db3;
  stroke: #000535;
}

.T1, .T2, .T3, .T4, .T5, .T6, .T7, .T8, .T9, .T10, .T11, .T12 {
  fill: #9fd4eb;
}

.T1:hover, .T2:hover, .T3:hover, .T4:hover, .T5:hover, .T6:hover, 
.T7:hover, .T8:hover, .T9:hover, .T10:hover, .T11:hover, .T12:hover {
  fill: #3fabd9;
}

.T1.selected, .T2.selected, .T3.selected, .T4.selected, .T5.selected, .T6.selected, 
.T7.selected, .T8.selected, .T9.selected, .T10.selected, .T11.selected, .T12.selected {
  fill: #3fabd9;
  stroke: #00456c;
}

.L1, .L2, .L3, .L4, .L5 {
  fill: #c1ebc2;
}

.L1:hover, .L2:hover, .L3:hover, .L4:hover, .L5:hover {
  fill: #82d784;
}

.L1.selected, .L2.selected, .L3.selected, .L4.selected, .L5.selected {
  fill: #82d784;
  stroke: #12551b;
}

.SACRUM {
  fill: #9fc49f;
}

.SACRUM:hover {
  fill: #40883f;
}

.SACRUM.selected {
  fill: #40883f;
  stroke: #002700;
}

.COCCYX {
  fill: #97b79b;
}

.COCCYX:hover {
  fill: #2f6e32;
}

.COCCYX.selected {
  fill: #2f6e32;
  stroke: #000f00;
}

.outline{
  fill:#686969;
}
</style>
